import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sn-sso-mobile-success',
  templateUrl: './sso-mobile-success.component.html',
  styleUrls: ['./sso-mobile-success.component.scss'],
})
export class SsoMobileSuccessComponent implements OnInit, OnDestroy {
  public url: any;

  private readonly _destroy$ = new Subject<void>();

  constructor(private readonly _route: ActivatedRoute, private readonly _sanitizer: DomSanitizer) {}

  public ngOnInit(): void {
    this._route.params.pipe(takeUntil(this._destroy$)).subscribe((data) => {
      const app = localStorage.getItem('app-origin') || 'ops';
      const mobile = data['mobile'];
      if (this._route.parent.snapshot.params.app !== app) {
        window.location.href = `/${app}/sso/mobile/success/${data['mobile']}/${data['token']}`;
        return;
      }
      if (mobile === 'ios') {
        this.url = this._sanitizer.bypassSecurityTrustResourceUrl(
          `/${app}/sso/mobile/success/${mobile}/${data['token']}`,
        );
      } else {
        const path = this._route.parent.snapshot.params.app || 'ops';
        this.url = this._sanitizer.bypassSecurityTrustResourceUrl(
          `intent://fususone.com/${path}/login?status=success&token=${data['token']}#Intent;scheme=https;end`,
        );
      }
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
